mod.modules.define("AdvancedChart", "BaseModule", function(fn) {

	fn.prototype.chart = null;

	var cache = {
		// DOM
		$saveModal: null,
		$saveModalInput: null,
		$savedList: null,
		$saveButton: null,
		$customTFModal: null,
		$startDate: null,
		$endDate: null
	};

	fn.prototype.init = function(params) {
		this.base("init", params);

		this.API_SAVE_CHART = "~/Chart/AddSavedChart";
		this.API_DELETE_CHART = "~/Chart/DeleteSavedChart";
		this.TRENDLINE_SRC = params.trendlineSrc;

		this.isExpandedModule = (this.el.data("size") == "4");
		this.isLargeModule = (this.el.data("size") == "3");

		if (this.isLargeModule || this.isExpandedModule) {
			//custom timeframe
			cache.$customTFModal = this.el.find("div#advanced-chart-customtf-modal");
			cache.$startDate = cache.$customTFModal.find("input.startDate");
			cache.$endDate = cache.$customTFModal.find("input.endDate");

			this.initCustomTimeframe();
		}

		if (this.isExpandedModule) {
			//save settings
			cache.$saveModal = $("div#advanced-chart-save-modal");
			cache.$saveModalInput = cache.$saveModal.find("input");
			cache.$savedList = this.el.find("ul.advanced-chart-saved");
			cache.$saveButton = this.el.find("button[data-action=openSaveChart]");
			cache.$saveModalInput.defaultValue();
		}

		this.initChart(params);
	};

	fn.prototype.initChart = function (inputs) {
		this.chart = new InteractiveChart();
		this.chart.SetContainer(this.el.find(".interactive-chart"));
		this.chart.API_DRAW_CHART = "~/Chart/AdvancedChart";
		this.chart.API_COMMENTARY = "~/Chart/GetCommentary";
		this.chart.REQUESTPARAMS = [{ appId: this.el.attr("data-widgetid"), context: this.getContext() }];
		this.chart.Init();

		this.chart.SetIssueDisplayName(inputs.issueDisplayName);
		this.chart.SetInputData(JSON.parse(inputs.chartInputs));
		this.chart.SetBaseIssueID(inputs.issueId);

		if (inputs.chartOutput) {
			this.chart.SetOutputData(JSON.parse(inputs.chartOutput), inputs.chartFileName);
		}


		// Add tools
		this.chart.SetTool(new EventTool());

		if (this.isExpandedModule) {
			// Add tools
			this.chart.SetTool(new CrosshairZoomTool());
			this.chart.SetTool(new LineTrackingTool());
			this.chart.SetTool(new ActiveLabelTool());

			this.chart.Subscribe("OverlayRemoved", this.handleOverlayRemoved.Context(this));
			this.chart.Subscribe("ComparisonRemoved", this.handleComparisonRemoved.Context(this));
			this.chart.RegisterChartSuccessCallback(this.handleCursorOptions.Context(this));
		}
	};

	fn.prototype.events = {
		"div.chart-timeframe .btn[data-action != custom]": {
			"click": function(e, $el) {
				this.handleChangeTimeframe(e, $el);
			}
		},
		".module-expand": {
			"click": function(e, $el) {
				var newSize = 4;
				var type = $el.attr("data-type");
				var newId = mod.modules.getKeyFromTypeSize(type, newSize);
				var context = $el.attr("data-context");

				if (context) {
					context = JSON.parse(context) || {};
				}

				this.handle_moduleExpand(newId, context);

				if ($el.attr("rel") == "tooltip") {
					$el.trigger("mouseleave");
				}
			}
		},
		".dropdown-menu li a[data-value]": {
			"click": function(e, $el) {
				e.preventDefault();
				this.handleActionMenu(e, $el);
			}
		},
		".dropdown-menu li a[data-issue]": { //symbol lookup
			"click": function(e, $el) {
				e.preventDefault();
				this.chart.PricePanel.AddComparison(
						new Comparison($el.data("issue") + "", $el.data("auto-symbol"))
				);

				this.updatePrint();
				this.chart.Update();
			}
		},
		".dropdown-menu li input": { //symbol lookup
			"click": function(e, $el) {
				e.stopImmediatePropagation();
			}
		},
		"button": {
			"click": function(e, $el) {
				this.handleButton(e, $el);
			}
		},
		"ul.advanced-chart-saved li": {
			"click": function(e, $el) {
				this.handleSavedChartSettings(e, $el);
			}
		}
	};

	fn.prototype.handleButton = function(e, $el) {
		var action = $el.data("action");

		if (action == "startOver") {
			this.reload({ SavedChartName: "" });
		}
		else if (action == "closeSaveChart") {
			cache.$saveModal.hide();
			cache.$saveModalInput.val("");
		}
		else if (action == "openSaveChart") {
			if ($el.hasClass("disabled")) {
				alert("You have reached the maximum number of saved settings allowed.");
			}
			else {
				cache.$saveModal.show();
			}
		}
		else if (action == "saveChart") {
			this.handleSaveChart();
		}
		else if (action == "custom") {
			cache.$customTFModal.show();
		}
		else if (action == "closeCustomTF") {
			cache.$customTFModal.hide();
		}
		else if (action == "saveCustomTF") {
			var fromDate = jsToMsDate(new Date(cache.$startDate.val()));
			var toDate = jsToMsDate(new Date(cache.$endDate.val()));

			if (fromDate > toDate) {
				alert("Please select a valid date range.");
			}
			else {
				this.chart.SetDateRange(fromDate, toDate);
				this.setCustomTFInterval(fromDate, toDate);
				this.updatePrint();
				this.chart.Update();

				cache.$customTFModal.hide();
			}
		}
	};

	fn.prototype.setCustomTFInterval = function (fromDate, toDate) {
		var days = toDate - fromDate;
		var interval = 1;
		var period = 2;

		if (days <= 21) {
			period = 0; //intra-day data usually only available for 21 days
			if (days > 1) {
				interval = 5;
			}
		} else if (days <= 365) {
			period = 2;
		} else if (days <= 1825) {
			period = 3;
		} else {
			period = 4
		}

		this.handleFrequencyOptions(days, period);

		this.chart.SetInterval(interval);
		this.chart.SetPeriod(period);
	};

	fn.prototype.handleFrequencyOptions = function (days, period) {
		// update frequency menu
		var menu = this.el.find("a[data-action=timeperiod][data-value=" + period + "]");
		menu.parent().siblings().removeClass("selected");
		menu.parent().addClass("selected");

		// enable/disable intra-day selection
		if (days > 21) {
			this.el.find("a[data-action=timeperiod][data-value=0]").closest("li").addClass("disabled");
		} else {
			this.el.find("a[data-action=timeperiod][data-value=0]").closest("li").removeClass("disabled");
		}
	};

	fn.prototype.handleChangeTimeframe = function(e, $el) {
		if ($el.hasClass("active")) { return false; }

		var days = $el.data("action");
		var period = $el.data("period");
		var interval = $el.data("interval");

		this.chart.SetNumberOfDays(days);
		this.chart.SetInterval(interval);
		this.chart.SetPeriod(period);

		if (this.isExpandedModule) {
			this.handleFrequencyOptions(days, period);
		}

		this.updatePrint();
		this.chart.Update();
	};

	fn.prototype.handleActionMenu = function(e, $el) {
		var parent = $el.parent();
		var action = $el.data("action");

		if (parent.hasClass("disabled")) {
			if (action != "timeperiod") {
				alert("Log-in to view Value Line Indicators.");
			}
		}
		else {
			var isSelected = parent.hasClass("selected");
			var value = $el.data("value");
			var selType = parent.data("seltype");

			if (!isSelected) {
				if (selType == "single") {
					parent.siblings().removeClass("selected");
				}

				parent.addClass("selected");
			}

			if (action == "panel") {
				if (!isSelected) {
					var oPanel = new Panel();
					oPanel.SetInputs({ Type: value, Height: 100, YAxisPosition: "Right" });
					this.chart.AddPanel(oPanel);
					parent.attr("data-uid", oPanel.GetUID());
				}
				else {
					this.chart.RemovePanelByType(value);
					parent.removeClass("selected");
				}
			}
			else if (action == "overlay" || action == "event") {
				if (!isSelected) {
					var oOverlay = new Overlay(value);

					if (action == "event") {
						oOverlay.SetParameter("Show", "True");
					}

					this.chart.PricePanel.AddOverlay(oOverlay);
					parent.attr("data-uid", oOverlay.GetUID());
				}
				else {
					this.chart.PricePanel.RemoveOverlay(value); //will remove menu selection
				}
			}
			else if (action == "timeperiod") {
				this.chart.SetInterval(value == "0" ? 5 : 1);
				this.chart.SetPeriod(value);
			}
			else if (action == "style") {
				this.chart.SetStyle(value);
				//this.chart.PricePanel.SetShowCloseChange(false);
			}
			else if (action == "scale") {
				this.chart.PricePanel.SetScale(value);
			}
			else if (action == "comparison") {
				if (!isSelected) {
					this.chart.PricePanel.AddComparison(
					 new Comparison(value + "", $el.text())
					);
				}
				else {
					this.chart.PricePanel.RemoveComparison(value); //will remove menu selection
				}
			}
			else if (action == "cursor") {
				this.handleCursorOptions(value);
			}
			else if (action == "trendline") {
				if (value == "trendLineOn") {
					this.addTrendLine();
				}
				else {
					this.removeTrendLine();
				}
			}

			if (action != "cursor" && action != "trendline") {
				this.updatePrint();
				this.chart.Update();
			}
		}
	};

	fn.prototype.handleCursorOptions = function(value) {
		var container = this.chart.GetContainer();

		//get value from inputs
		if (!value) {
			var oInputs = this.chart.GetInputData();
			value = oInputs.Cursor || "line";
		}

		if (value) {
			container.attr("data-cursor", value);
			var oInputs = this.chart.GetInputData();
			oInputs.Cursor = value;
		}
	};

	fn.prototype.addTrendLine = function() {
		var $trendlinesContainer = $("<div class='trendlinesContainer'></div>");
		var panel = this.chart.PricePanel.GetContainer();
		panel.append($trendlinesContainer);

		//turn off cursor and mouseovers
		var container = this.chart.GetContainer();
		container.attr("data-cursor", "noLine");

		TrendLine.prototype.imgHandleProps.src = this.TRENDLINE_SRC;
		TrendLine.prototype.blockTrendLabels = true;
		var pen = new TrendLineCanvas($trendlinesContainer);
	};

	fn.prototype.removeTrendLine = function() {
		var panel = this.chart.PricePanel.GetContainer();
		panel.find('div.trendlinesContainer').remove();
		this.handleCursorOptions();
	};

	fn.prototype.handleOverlayRemoved = function(rArgs) {
		var arg = rArgs[0];

		if (arg in this.chart.PricePanel._overlaysByUID) {
			$("div.advanced-chart-header li[data-uid=" + arg + "]").removeClass("selected");
		} else {
			$("div.advanced-chart-header li a[data-value=" + arg + "]").parent().removeClass("selected");
		}
	};

	fn.prototype.handleComparisonRemoved = function(rArgs) {
		var sSymbol = "";
		var arg = rArgs[0];
		if (arg in this.chart.PricePanel._comparisonsByUID) {
			var oCompData = this.chart.PricePanel.GetComparisonByInputDataUid(arg);
			sSymbol = oCompData.Symbol;
		} else if (arg in this.chart.PricePanel._comparisonsBySymbol) {
			sSymbol = arg;
		}

		if (sSymbol) {
			$("div.advanced-chart-header li a[data-value=" + sSymbol + "]").parent().removeClass("selected");
		}
	};

	fn.prototype.handleSavedChartSettings = function(e, $el) {
		var name = $el.find("a").text();
		var target = $(e.target);

		if (name.length > 0) {
			if (target.hasClass("icon-remove")) {
				this.deleteSavedChart({ chartName: name }, $el);
			} else {
				this.reload({
					SavedChartName: name
				});
			}
		}
	};

	fn.prototype.handleSaveChart = function() {
		var name = cache.$saveModalInput.val();

		if (name.replace(/\s/g, '').length) {
			var re = /^[0-9a-zA-Z ]+$/;
			if (re.test(name)) {
				this.addSavedChart({ chartName: name });
			} else {
				alert("Please enter alphanumeric characters only.");
			}
		} else {
			alert("Please enter a name for the chart setting.");
		}
	};

	fn.prototype.addSavedChart = function(oData) {
		var self = this;
		$.ajax({
			type: "POST",
			data: oData,
			dataType: "json",
			url: this.API_SAVE_CHART.resolveUrl(),
			success: function() {
				var $parent = cache.$savedList.parent();
				cache.$savedList.detach();
				cache.$savedList.append("<li><a href='javascript:;'>" + oData.chartName + "</a><i class='icon-remove' /></li>");
				cache.$savedList.appendTo($parent);

				self.updateSaveButton();

				cache.$saveModal.hide();
			},
			error: function() { cache.$saveModal.hide(); }
		});
	};

	fn.prototype.deleteSavedChart = function(oData, $el) {
		var self = this;
		$.ajax({
			type: "POST",
			data: oData,
			dataType: "json",
			url: this.API_DELETE_CHART.resolveUrl(),
			success: function() {
				$el.remove();
				self.updateSaveButton();
			},
			error: function() { }
		});
	};

	fn.prototype.updateSaveButton = function() {
		var max = cache.$saveButton.data("max");
		var item = cache.$savedList.find("li");

		if (item.length >= max) {
			cache.$saveButton.addClass("disabled");
		} else {
			cache.$saveButton.removeClass("disabled");
		}
	};

	fn.prototype.initCustomTimeframe = function() {
		cache.$startDate.datepicker({ maxDate: '0' });
		cache.$endDate.datepicker({ maxDate: '0' });
	};

	fn.prototype.updatePrint = function () {
		var newParams = {};

		//Update print button
		var printLink = $("A.action-print", this.el);
		var context = $.extend({}, this.getContext(), newParams);
		this.setContext(context);

		if (printLink.length > 0) { //Update the print link
			var contextSearch = "context:";

			if (context["PrintView"] == undefined) { //reinsert it for this
				context["PrintView"] = true;
			}

			var rawPrintURL = printLink.attr("href");
			var printURL = rawPrintURL.substring(0, rawPrintURL.indexOf(contextSearch) + contextSearch.length);
			var serContext = JSON.stringify(context);
			var params = printURL + serContext + "}]";

			printLink.attr("href", params);
		}
	};
});